import { Group, Badge, ActionIcon } from '@mantine/core'
import React from 'react'
import { useCurrentRefinements } from 'react-instantsearch'
import Icon from 'components/Icon/Icon'
import {
  translateRefinementLabel,
  translateTypesenseAttribute,
} from '../helpers'

const excludedAttributes = ['category.lvl0', 'category.lvl1', 'category.lvl2']

export const CurrentRefinements = () => {
  const { items, refine } = useCurrentRefinements()

  const handleRemove = (refinement: any) => {
    refine(refinement)
  }

  if (items.length === 0) {
    return null
  }

  return (
    <Group
      gap="0.5rem"
      wrap="nowrap"
      styles={{
        root: {
          overflowX: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::WebkitScrollbar': {
            display: 'none',
          },
        },
      }}
    >
      {items.flatMap((item) =>
        item.refinements
          .filter(
            (refinement) => !excludedAttributes.includes(refinement.attribute)
          )
          .map((refinement) => (
            <Badge
              key={`${item.indexId}-${refinement.value}`}
              variant="light"
              color="var(--mantine-color-piney-lake-1)"
              size="md"
              px="1rem"
              h="2.25rem"
              radius="0.375rem"
              display="flex"
              styles={{
                root: {
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap',
                  width: 'auto',
                  textOverflow: 'initial',
                  overflow: 'visible',
                },
              }}
              tt="inherit"
              rightSection={
                <ActionIcon
                  size="1.25rem"
                  color="primary.300"
                  variant="transparent"
                  onClick={(event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    handleRemove(refinement)
                  }}
                  aria-label={`Remove ${refinement.label}`}
                >
                  <Icon.Cross size={24} />
                </ActionIcon>
              }
              onClick={() => handleRemove(refinement)}
            >
              {translateTypesenseAttribute({ value: refinement.attribute })}{' '}
              {translateRefinementLabel({
                value: refinement.label,
                attribute: refinement.attribute,
                realValue: refinement.value,
                operator: refinement.operator,
              })}{' '}
            </Badge>
          ))
      )}
    </Group>
  )
}
